import { ConverterFindDto, type ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { ExternalUserFindDto, type ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { UserFindDto, UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { FilialFindInterface } from '@zaoblako/shared/modules/catalog/dtos/filial/filial-find.dto';
import { ClientFindDto, type ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';

import * as yup from 'yup';

/** Room response body */
export interface RoomFindInterface {
  /** Unique identifier. Cannot be changed */
  id: number;
  /** Display name. */
  name: string;
  /** Room area in square meters */
  square: number;
  /** Related filial */
  filial?: FilialFindInterface;
  /** Room entrance converters */
  converters?: ConverterFindInterface[];
  /** Related external users */
  externalUsers?: ExternalUserFindInterface[];
  /** Related client */
  client?: ClientFindInterface;
  /** Related users who have access to the premises */
  allowUsers?: UserFindInterface[];
}

/** Room response body - DTO schema */
export const RoomFindDto = SerdeDtoClass.create<RoomFindInterface>(CatalogDtosKeysEnum.ROOM_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  square: {
    optional: true,
    label: 'Площадь',
    serializer: yup.number(),
  },
  filial: {
    optional: true,
    label: 'Филиал',
    nested: CatalogDtosKeysEnum.FILIAL_FIND_DTO,
    serializer: (_, nested) => nested,
  },
  client: {
    optional: true,
    label: 'Клиент',
    nested: ClientFindDto,
    serializer: (_, nested) => nested,
  },
  converters: {
    optional: true,
    label: 'Конвертеры',
    nested: ConverterFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  externalUsers: {
    optional: true,
    label: 'Контакты',
    nested: ExternalUserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  allowUsers: {
    optional: true,
    label: 'Пользователи, имеющие доступ к помещению',
    nested: UserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
